import Head from "next/head";
import { GetStaticProps } from "next";

import SeoMetaData from "@/components/utils/seo-metadata";
import pageSeoData from "@/data/seo/page-data.json";
import UpsCanadaMain from "@/components/fulfilment-partners/ups-canada-main";
import { PageSeoHeaderProps } from "@/@types/SeoHeader";

export default function UPSCanada({ seoData }: PageSeoHeaderProps) {
  return (
    <>
      <Head>
        <title>{seoData.title}</title>
        <SeoMetaData data={seoData} />
      </Head>

      <UpsCanadaMain />
    </>
  );
}

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: { seoData: pageSeoData.PARTNER_UPS_CANADA },
  };
};
